module.exports = __webpack_public_path__ + "fonts/CashSans-Black.c6dcf2f.woff2";